import React from 'react'
import { node, bool, string } from 'prop-types'
import classNames from 'classnames'

import Type from '../Type'
import SmartLink from '../SmartLink'

import styles from './Tag.module.scss'

const Tag = ({
  children,
  themed,
  themedFont,
  italic,
  background,
  uppercase,
  style,
  className,
  nofollow,
  href
}) => {
  const Wrapper = href ? SmartLink : 'div'
  return (
    <Wrapper
      as={href}
      to={href}
      style={style}
      rel={nofollow ? 'nofollow' : undefined}
      className={classNames(
        styles.Tag,
        italic && styles.italic,
        themed && styles.themed,
        uppercase && styles.uppercase,
        background && styles[background],
        className
      )}
    >
      <Type
        as="span"
        weight={italic && 'medium'}
        italic={italic}
        size={italic ? ['body2', 'body5'] : ['body2', 'body4']}
        themed={themedFont}
      >
        {children}
      </Type>
    </Wrapper>
  )
}

Tag.defaultProps = {
  background: 'transparent'
}

Tag.propTypes = {
  children: node,
  themed: bool,
  themedFont: bool,
  background: string,
  italic: bool,
  uppercase: bool,
  style: string,
  href: string,
  className: string,
  nofollow: bool
}

export default Tag
